'use es6';

import { createTracker } from 'usage-tracker-public';
import events from 'MeetingsLib/events.yaml';
import { MEETINGS_APP_NAME } from 'MeetingsBase/constants/strings';
const DEFAULT_LOCALE = 'en';
let tracker = null;
let screen = 'public';
export function initializeMeetingsLibTracker(email, portalId, embedded, locale) {
  screen = embedded ? 'embedded' : 'public';
  tracker = createTracker({
    events,
    properties: {
      namespace: MEETINGS_APP_NAME,
      email,
      hubId: portalId,
      lang: locale || window.I18n ? window.I18n.locale : DEFAULT_LOCALE,
      screen
    }
  });
  return tracker;
}
export function track(eventKey, eventProperties = {}) {
  if (tracker) {
    tracker.track(eventKey, Object.assign({
      screen
    }, eventProperties));
  }
}